/** Shared Mapterhorn DEM config for map terrain + elevation sampling. */

export const MAPTERHORN_DEM_SOURCE_ID = 'mapterhorn-dem'

export const MAPTERHORN_TILES_ORIGIN = 'https://tiles.mapterhorn.com'

export const MAPTERHORN_TILEJSON_URL = `${MAPTERHORN_TILES_ORIGIN}/tilejson.json`

export const MAPTERHORN_TILE_SIZE = 512

export const MAPTERHORN_DEM_ATTRIBUTION =
  'Terrain data by <a href="https://mapterhorn.com/" target="_blank" rel="noopener noreferrer">Mapterhorn</a>'
